import {
    takeLatest, all, put, call, takeEvery, take, fork,
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/SeminarManagementOrganizer';

function* getListSeminarManagement(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/company/${credential.data.company_id}/seminar/`;
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {
                    page: action.payload.page,
                    page_size: action.payload.page_size,
                },
            },
        );
        yield put(Actions.GetListSeminarRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetListSeminarRequestedReceivedFailure(yield error));
    }
}
function* getDetailSeminar(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = action.payload?.language
            ? `/api/v1/company/${credential.data.company_id}/seminar/${action.payload.seminarId}/?language=${action.payload.language}`
            : `/api/v1/company/${credential.data.company_id}/seminar/${action.payload}/`;
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailSeminarRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailSeminarRequestedReceivedFailure(yield error));
    }
}

function* updateSeminar(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/company/${credential.data.company_id}/seminar/${action.payload.seminar_id}/`;
        const [uploadPromise, channel] = createUploaderChannel(action.payload, credential.data.token, endpoint);
        yield fork(uploadProgressWatcher, channel);
        const response = yield call(() => uploadPromise);

        yield put(Actions.UpdateSeminarRequestedReceived(response));
    } catch (error) {
        yield put(Actions.UpdateSeminarRequestedReceivedFailure(yield error));
    }
}

function createUploaderChannel(payload, token, endpoint) {
    let emit;
    const chan = eventChannel((emitter) => {
        emit = emitter;
        // it's necessarily. event channel should
        // return unsubscribe function. In our case
        // it's empty function
        return () => {};
    });

    const onProgress = (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        emit(percentCompleted);
        if (percentCompleted === 100) emit(END); // 100 percent emit end
        else emit(percentCompleted);
    };

    const uploadPromise = API.putWithFile({
        endpoint,
        body: payload.data,
        token,
        onProgress,
    });

    return [uploadPromise, chan];
}
function* uploadProgressWatcher(channel) {
    while (true) {
        const progress = yield take(channel);
        yield put(Actions.UpdateSeminarProgess(progress));
    }
}

export default function* seminarManagementOrganizer() {
    yield all([
        takeEvery('GET_LIST_SEMINAR_REQUESTED', getListSeminarManagement),
        takeEvery('GET_DETAIL_SEMINAR_REQUESTED', getDetailSeminar),
        takeLatest('UPDATE_SEMINAR_REQUESTED', updateSeminar),
    ]);
}
